import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';

import amplitude from './amplitude';
import amplitudeDeviceTracking from './amplitudeDeviceTracking';

const trackDevicesPageScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.DEVICE_SECTION_VIEWED);
};

const trackTryYourFirstIqosButtonClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.TRY_YOUR_FIRST_IQOS_BUTTON_CLICKED);
};

const trackAboutMyDeviceScreen = () => {
    amplitudeDeviceTracking.trackDeviceFromStateEvent(amplitudeEventNames.ABOUT_MY_DEVICE_SCREEN_VIEWED);
};

const trackTipsAndTutorialsScreen = () => {
    amplitudeDeviceTracking.trackDeviceFromStateEvent(amplitudeEventNames.TIPS_AND_TUTORIAL_SCREEN_VIEWED);
};

export default {
    trackDevicesPageScreen,
    trackTryYourFirstIqosButtonClick,
    trackAboutMyDeviceScreen,
    trackTipsAndTutorialsScreen,
};
